var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DossierActivityDomainPanel',{attrs:{"editable":true,"activity":this.$store.state.user.activeActivity},on:{"contentUpdated":_vm.contentUpdated}})
}
var staticRenderFns = []

export { render, staticRenderFns }